import { useAppSelector } from "store/store";
import { enlargeSelector } from "store/features/enlarge/selectors/enlargeSelector";
import { EnlargeState } from "store/features/enlarge/types";

export const useResizeSettings = () => {
    const {
        resizeSettings: { dimensionType, isLocked, unit },
    } = useAppSelector(enlargeSelector, equalityFn);

    return { dimensionType, isLocked, unit };
};

const equalityFn = (left: EnlargeState, right: EnlargeState) => {
    if (
        left.resizeSettings.dimensionType !== right.resizeSettings.dimensionType ||
        left.resizeSettings.isLocked !== right.resizeSettings.isLocked ||
        left.resizeSettings.unit !== right.resizeSettings.unit
    )
        return false;

    return true;
};
